import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ITranslatableText } from 'src/app/store/services/store.service';
import { SettingService } from './setting.service';
import { finalize, Observable } from 'rxjs';
import { ImageService } from './image.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { ApiControllerService } from './api-controller.service';

export interface IBaseAchievementsRequest {
  merchantId: string;
}

export interface IAchievements {
  id: string;
  merchantId: string;
  challenges: IChallenge[];
}

export interface IChallenge {
  id: string
  challengeName: ITranslatableText;
  shortDescription: ITranslatableText;
  challengeType: string;
  links: string;
  googleAppLink: string;
  appleStoreLink: string;
  deactivate: boolean;
  pointsEarned: number;
  numberOfUses: number;
  creationDate: Date;
  editingDate: Date;
  createdBy: string;
  lastEditedBy: string;

  _processing: boolean;
}

export interface IAchievementsInteraction {
  merchantId: string
  userId: string;
  challengeId: string;
}

export interface IAchievementsProfile {
  merchantId: string
  userId: string;
}

export interface IAchievementsUserStatus {
  id: string;
  userId: string;
  merchantId: string;
  challengeUserComplete: IChallengeUserComplete[];
}

export interface IChallengeUserComplete {
  challengeId: string;
  pointsEarned: number;
  completionCount: number;
  lastInteractionDate: Date;
}

@Injectable({
  providedIn: 'root',
})
export class AchievementsService {
  
  achievements: IAchievements;
  //userAchievementProfile: IAchievementsUserStatus; -> put it later since it needs to follow the login logout flow

  constructor(
    private http: HttpClient,
    private settingService: SettingService,
    private authService: AuthService,
    private apiController: ApiControllerService
  ) { }

  getAchievements(achievementsRequest: IBaseAchievementsRequest): Observable<IAchievements> {
    return Observable.create(o => {
      if(this.achievements) {
        o.next(this.achievements);
        o.complete();
      } else {
        /* this.http.post(this.settingService.apiUrl('Achievements/GetAchievements'), achievementsRequest)
        .subscribe((data: any) => {
          this.achievements = data;
          o.next(data);
          o.complete();
        }); */
        this.apiController.post(this.settingService.apiUrl('Achievements/GetAchievements'), achievementsRequest)
        .subscribe((data: any) => {
          this.achievements = data;
          o.next(data);
          o.complete();
        });
      }
      
    })
  }

  AchievementsInteraction(achievementsInteractionRequest: IAchievementsInteraction): Observable<boolean> {
    return Observable.create(o => {
      /* this.http.post(this.settingService.apiUrl('Achievements/CompleteAchievementChallenge'), achievementsInteractionRequest)
        .subscribe((data: any) => {
          o.next(data);
          o.complete();
        }); */
      this.apiController.post(this.settingService.apiUrl('Achievements/CompleteAchievementChallenge'), achievementsInteractionRequest)
        .subscribe((data: any) => {
          o.next(data);
          o.complete();
        });
    })
  }

  getAchievementsProfile(achievementsProfileRequest: IAchievementsProfile): Observable<IAchievementsUserStatus> {
    return Observable.create(o => {
      /* this.http.post(this.settingService.apiUrl('Achievements/GetAchievementsProfile'), achievementsProfileRequest)
        .subscribe((data: any) => {
          o.next(data);
          o.complete();
        }); */
      this.apiController.post(this.settingService.apiUrl('Achievements/GetAchievementsProfile'), achievementsProfileRequest)
        .subscribe((data: any) => {
          o.next(data);
          o.complete();
        });
    })
  }

  // broken at the moment.
  sendEmailInvites(achievementsProfileRequest: IAchievementsProfile): Observable<IAchievementsUserStatus> {
    // this will be used through SMS to search the emails based on store ID. it's required to communicate to the API.
    //this.authService.getAuthHeadersBaseObject

    return Observable.create(o => {
      /* this.http.post(this.settingService.apiUrl('Achievements/GetAchievementsProfile'), achievementsProfileRequest)
        .subscribe((data: any) => {
          o.next(data);
          o.complete();
        }); */
      this.apiController.post(this.settingService.apiUrl('Achievements/GetAchievementsProfile'), achievementsProfileRequest)
        .subscribe((data: any) => {
          o.next(data);
          o.complete();
        });
    })
  }
}
